<template>
  <div>
    <b-row
      v-for="(item, index) in ComplaintList"
      :id="item.complaint.complaintId"
      :key="index"
    >
      <div class="border border-primary rounded-lg mt-2">
        <b-col md="12">
          <h3 class="mt-1">
            {{ item.complaint.complaintCode }}
          </h3>

          <TabAttachFiles
            @handle-upload="onAttachFileUploaded"
            @handle-delete="onAttachFileDelete"
            :attachFiles="item.complaint.attachFiles"
            :keyId="item.complaint.complaintId"
          />
        </b-col>
      </div>
    </b-row>
    <b-row>
      <b-col cols="6" class="d-flex justify-content-start mt-2">
        <b-button variant="secondary" @click="onBackBtnClicked">
          ย้อนกลับ
        </b-button>
      </b-col>
      <b-col cols="6" class="d-flex justify-content-end mt-2">
        <b-button variant="primary" @click="onSubmitBtnClicked">
          ยืนยัน
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from "bootstrap-vue";
import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
import TabAttachFiles from "./service/TabAttachFiles.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    ComplaintAPI,
    TabAttachFiles,
  },
  data() {
    return {
      ComplaintList: [],
      attachFiles: [
        {
          fileName: "portal-button-2-c.png",
          fileSize: 0,
          fileBase64: null,
          fileType: null,
          masterId: null,
          userId: "00000000-0000-0000-0000-000000000000",
          filePath:
            "https://localhost:44394/Uploads/25650129/346/portal-button-2-c.png",
          attachId: 343,
          fileUploadId: 346,
          createDate: "2022-01-29T10:52:58.1415791",
          createDateStr: "29 มกราคม 2565",
          downloadCount: 0,
          masterDescription: "ฉลากสินค้า",
          isAdd: true,
          keyId: "cad5f219-d672-4c95-8de8-8ed30e1a0b4e",
        },
      ],
      parentComponent: '',
    };
  },
  beforeMount() {
    var self = this;

    ComplaintAPI.GetComplaintList(
      self.$route.query.complaintGuid
      //,self.$route.query.isGroupGuid
    )
      .then(function(response) {
        self.ComplaintList = response.data.data;
      })
      .catch(function(error) {
        console.log("error", error);
      })
      .then(function() {});

      this.parentComponent = this.$route.query.parentComponent
  },
  methods: {
    onAttachFileUploaded(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    onBackBtnClicked() {
      if (this.parentComponent !== null && this.parentComponent !== undefined && this.parentComponent !== '') {
        console.log('this.parentComponent !== null', this.parentComponent)
        this.$router.push({ name: this.parentComponent })
      }
      else {
        this.$router.push({ name: 'dashboard-ecommerce' })
      }
    },
    onSubmitBtnClicked() {
      if (this.parentComponent === 'ProvincialComplaint') {
        this.$router.push({ name: 'ProvincialOfficer' })
      }
      else {
        // this.$router.push({ name: 'ComplaintHistory' }) 
        this.$router.push({ name: 'attachment' }) 
      }
      
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
